import { render, staticRenderFns } from "./fourth_step.vue?vue&type=template&id=2e6164be&scoped=true&"
import script from "./fourth_step.vue?vue&type=script&lang=js&"
export * from "./fourth_step.vue?vue&type=script&lang=js&"
import style0 from "./fourth_step.vue?vue&type=style&index=0&id=2e6164be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6164be",
  null
  
)

export default component.exports